/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

/* Related color thumbnails hover + slider for Pipeline */
(function () {
  function getProductCard(element) {
    return element.closest('product-grid-item') || element.closest('.product-grid-item');
  }

  function getMainImage(card) {
    if (!card) return null;

    const images = Array.from(card.querySelectorAll('img')).filter(function (img) {
      return !img.closest('.color-related-products');
    });

    return images[0] || null;
  }

  function getProductLinks(card) {
    const links = Array.from(card.querySelectorAll('a[href]')).filter(function (link) {
      return !link.closest('.color-related-products');
    });

    return links;
  }

  document.addEventListener('mouseover', function (event) {
    const item = event.target.closest('.color-related-products__item');
    if (!item) return;

    if (window.matchMedia('(hover: none), (pointer: coarse), (max-width: 749px)').matches) return;

    const group = item.closest('.color-related-products');
    if (!group) return;

    const card = getProductCard(group);
    if (!card) return;

    const mainImage = getMainImage(card);
    const productLinks = getProductLinks(card);

    const hoverSrc = item.dataset.hoverSrc;
    const hoverUrl = item.dataset.hoverUrl;

    if (mainImage && !mainImage.dataset.originalSrc) {
      mainImage.dataset.originalSrc = mainImage.getAttribute('src') || '';
      mainImage.dataset.originalSrcset = mainImage.getAttribute('srcset') || '';
    }

    productLinks.forEach(function (link) {
      if (!link.dataset.originalHref) {
        link.dataset.originalHref = link.getAttribute('href') || '';
      }
    });

    if (mainImage && hoverSrc) {
      mainImage.setAttribute('src', hoverSrc);
      mainImage.setAttribute('srcset', hoverSrc);
    }

    if (hoverUrl) {
      productLinks.forEach(function (link) {
        link.setAttribute('href', hoverUrl);
      });
    }

    group.querySelectorAll('.color-related-products__item').forEach(function (el) {
      el.classList.remove('is-hovered');
    });

    item.classList.add('is-hovered');
  });

  document.addEventListener('mouseout', function (event) {
    const group = event.target.closest('.color-related-products');
    if (!group) return;

    if (window.matchMedia('(hover: none), (pointer: coarse), (max-width: 749px)').matches) return;

    if (group.contains(event.relatedTarget)) return;

    const card = getProductCard(group);
    if (!card) return;

    const mainImage = getMainImage(card);
    const productLinks = getProductLinks(card);

    if (mainImage && mainImage.dataset.originalSrc) {
      mainImage.setAttribute('src', mainImage.dataset.originalSrc);
    }

    if (mainImage && mainImage.dataset.originalSrcset) {
      mainImage.setAttribute('srcset', mainImage.dataset.originalSrcset);
    }

    productLinks.forEach(function (link) {
      if (link.dataset.originalHref) {
        link.setAttribute('href', link.dataset.originalHref);
      }
    });

    group.querySelectorAll('.color-related-products__item').forEach(function (el) {
      el.classList.remove('is-hovered');
    });
  });

  document.addEventListener('click', function (event) {
    const colorItem = event.target.closest('.color-related-products__item');
    if (!colorItem) return;

    const hoverUrl = colorItem.dataset.hoverUrl || colorItem.getAttribute('href');

    if (hoverUrl) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = hoverUrl;
    }
  });

  function updateSliderButtons(slider) {
  const track = slider.querySelector('.color-related-products');
  const prevButton = slider.querySelector('.color-related-products-slider__button--prev');
  const nextButton = slider.querySelector('.color-related-products-slider__button--next');

  if (!track || !prevButton || !nextButton) return;

  const maxScrollLeft = track.scrollWidth - track.clientWidth;

  if (maxScrollLeft <= 2) {
    prevButton.style.visibility = 'hidden';
    nextButton.style.visibility = 'hidden';
    prevButton.style.pointerEvents = 'none';
    nextButton.style.pointerEvents = 'none';
    return;
  }

  prevButton.style.visibility = 'visible';
  nextButton.style.visibility = 'visible';
  prevButton.style.pointerEvents = 'auto';
  nextButton.style.pointerEvents = 'auto';

  prevButton.disabled = track.scrollLeft <= 2;
  nextButton.disabled = track.scrollLeft >= maxScrollLeft - 2;
}

  function getScrollAmount(track) {
    const firstItem = track.querySelector('.color-related-products__item');
    if (!firstItem) return 100;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);

    return firstItem.offsetWidth + gap;
  }

  document.addEventListener('click', function (event) {
    const prevButton = event.target.closest('.color-related-products-slider__button--prev');
    const nextButton = event.target.closest('.color-related-products-slider__button--next');

    if (!prevButton && !nextButton) return;

    const slider = event.target.closest('.color-related-products-slider');
    if (!slider) return;

    const track = slider.querySelector('.color-related-products');
    if (!track) return;

    event.preventDefault();
    event.stopPropagation();

    const amount = getScrollAmount(track);

    track.scrollBy({
      left: nextButton ? amount : -amount,
      behavior: 'smooth',
    });

    window.setTimeout(function () {
      updateSliderButtons(slider);
    }, 300);
  });

  document.addEventListener(
    'scroll',
    function (event) {
      const track = event.target.closest && event.target.closest('.color-related-products');
      if (!track) return;

      const slider = track.closest('.color-related-products-slider');
      if (slider) updateSliderButtons(slider);
    },
    true
  );

  function initColorSliders() {
    document.querySelectorAll('.color-related-products-slider').forEach(function (slider) {
      updateSliderButtons(slider);
    });
  }

  document.addEventListener('DOMContentLoaded', initColorSliders);
  window.addEventListener('load', initColorSliders);
  window.addEventListener('resize', initColorSliders);
})();
